import { render } from "./PurchaseRecordsDialog.vue?vue&type=template&id=f007162c&scoped=true"
import script from "./PurchaseRecordsDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseRecordsDialog.vue?vue&type=script&lang=js"

import "./PurchaseRecordsDialog.vue?vue&type=style&index=0&id=f007162c&scoped=true&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f007162c"]])

export default __exports__